/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { DataType } from '../../DataType';
import { FFuncAgg } from '../FormulaFunc';
export var AggregateFunction;
(function (AggregateFunction) {
    AggregateFunction["AGG"] = "AGG";
    AggregateFunction["AVG"] = "AVG";
    AggregateFunction["COUNT"] = "COUNT";
    AggregateFunction["COUNTD"] = "COUNTD";
    AggregateFunction["MEDIAN"] = "MEDIAN";
    AggregateFunction["MIN"] = "MIN";
    AggregateFunction["MAX"] = "MAX";
    AggregateFunction["STDEV"] = "STDEV";
    AggregateFunction["STDEVP"] = "STDEVP";
    AggregateFunction["SUM"] = "SUM";
    AggregateFunction["VAR"] = "VAR";
    AggregateFunction["VARP"] = "VARP";
})(AggregateFunction || (AggregateFunction = {}));
export class AVG extends FFuncAgg {
    constructor(args) {
        super(AggregateFunction.AVG, args);
    }
    getReturnType(argTypes) {
        return DataType.FLOAT;
    }
    init(scope) {
        scope[this.id] = { sum: null, length: 0 };
    }
    step(scope, ...args) {
        const value = args[0](scope);
        if (value !== null && !isNaN(value)) {
            scope[this.id].length++;
            if (scope[this.id] === null) {
                scope[this.id] = value;
            }
            else {
                scope[this.id].sum += value;
            }
        }
    }
    final(scope) {
        if (scope[this.id].length === 0) {
            return null;
        }
        if (scope[this.id].sum === null) {
            return null;
        }
        return scope[this.id].sum / scope[this.id].length;
    }
}
export class COUNT extends FFuncAgg {
    constructor(args) {
        super(AggregateFunction.COUNT, args);
    }
    getReturnType(argTypes) {
        return DataType.INTEGER;
    }
    init(scope) {
        return (scope[this.id] = 0);
    }
    step(scope, ...args) {
        const value = args[0](scope);
        if (value != null) {
            scope[this.id]++;
        }
    }
    final(scope) {
        return scope[this.id];
    }
}
export class COUNTD extends FFuncAgg {
    constructor(args) {
        super(AggregateFunction.COUNTD, args);
    }
    getReturnType(argTypes) {
        return DataType.INTEGER;
    }
    init(scope) {
        scope[this.id] = new Set();
    }
    step(scope, ...args) {
        const value = args[0](scope);
        if (value !== null && value !== undefined) {
            scope[this.id].add(value);
        }
    }
    final(scope) {
        return scope[this.id].size;
    }
}
export class MAX extends FFuncAgg {
    constructor(args) {
        super(AggregateFunction.MAX, args);
    }
    getReturnType(argTypes) {
        if (this.argc > 0) {
            return argTypes[0];
        }
        else {
            return DataType.NUMBER;
        }
    }
    init(scope) {
        scope[this.id] = null;
    }
    step(scope, ...args) {
        const value = args[0](scope);
        if (isNaN(value)) {
            return;
        }
        else if (scope[this.id] === null) {
            scope[this.id] = value;
        }
        else {
            scope[this.id] = Math.max(scope[this.id], value);
        }
    }
    final(scope) {
        return scope[this.id];
    }
}
export class MIN extends FFuncAgg {
    constructor(args) {
        super(AggregateFunction.MIN, args);
    }
    getReturnType(argTypes) {
        if (this.argc > 0) {
            return argTypes[0];
        }
        else {
            return DataType.NUMBER;
        }
    }
    init(scope) {
        scope[this.id] = null;
    }
    step(scope, ...args) {
        const value = args[0](scope);
        if (isNaN(value) || value === null) {
            return;
        }
        else if (scope[this.id] === null) {
            scope[this.id] = value;
        }
        else {
            scope[this.id] = Math.min(scope[this.id], value);
        }
    }
    final(scope) {
        return scope[this.id];
    }
}
export class SUM extends FFuncAgg {
    constructor(args) {
        super(AggregateFunction.SUM, args);
    }
    getReturnType(argTypes) {
        if (this.argc > 0) {
            return argTypes[0];
        }
        else {
            return DataType.NUMBER;
        }
    }
    init(scope) {
        scope[this.id] = null;
    }
    step(scope, ...args) {
        const value = args[0](scope);
        if (!isNaN(value)) {
            if (scope[this.id] === null) {
                scope[this.id] = value;
            }
            else {
                scope[this.id] += value;
            }
        }
    }
    final(scope) {
        return scope[this.id];
    }
}
